import { ShieldAlert } from 'lucide-react'
import { formatTime } from '@/shared/infra/format'
import { useOrgContext } from '@/shared/ui/hooks'
import { Button } from '@/shared/ui/primitives'

function formatExpiry(expiresAt: string | null): string | null {
  if (!expiresAt) return null
  const formatted = formatTime(expiresAt)
  return formatted || null
}

export function ImpersonationBanner() {
  const { isImpersonating, impersonationOrgName, impersonationExpiresAt, stopImpersonation } =
    useOrgContext()
  if (!isImpersonating) return null

  const orgLabel = impersonationOrgName ? impersonationOrgName : 'this organization'
  const expiry = formatExpiry(impersonationExpiresAt ?? null)

  return (
    <div
      data-testid="impersonation-banner"
      role="status"
      className="flex shrink-0 items-center justify-between gap-2 border-b border-amber/40 bg-amber-soft px-4 py-2 text-2xs font-semibold uppercase tracking-wide text-amber sm:text-xs"
    >
      <div className="flex flex-1 items-center justify-center gap-2 text-center">
        <ShieldAlert className="size-4 shrink-0" aria-hidden />
        <span>
          Impersonating {orgLabel} as its owner — support session
          {expiry ? `, expires ${expiry}` : ''}
        </span>
      </div>
      <Button
        type="button"
        variant="outline"
        size="xs"
        onClick={() => {
          void stopImpersonation?.()
        }}
        aria-label="Stop impersonating"
        className="shrink-0 border-amber/50 bg-transparent text-amber hover:bg-amber/10"
      >
        Stop impersonating
      </Button>
    </div>
  )
}
